<template>
  <div class="case-detail-region-caller-dailog dialog col-block">
    <div class="title-container row-block">
      <div class="title">{{ $tc('DIALOG.caseDetailRegionCaller.___title', regionData.support_caller_count, { count: regionData.support_caller_count }) }}</div>
      <div :style="{ flex: 1 }"></div>
    </div>
    <div :style="{ height: '20px' }"></div>
    <div class="data-container col-block">
      <div class="data-title-container row-block">
        <div
          class="data-title"
          v-html="'chr' + regionData.SV_chrom + ': ' + regionData.SV_start + '-' + regionData.SV_end + ' ' + $t(svTypeValueMap[regionData.SV_type].title)"
        ></div>
        <div :style="{ flex: 1 }"></div>
      </div>
      <div :style="{ height: '15px' }"></div>
      <div class="data-content-container col-block flex-start width-full">
        <div class="data-content-block col-block">
          <div class="data-row row-block stretch">
            <div class="data-col col-block" v-for="(option, oindex) in tableOption" :key="oindex" :class="[option.position, { hidden: !option.title }]" :style="{ flex: option.flex }">
              <div :style="{ flex: 1 }"></div>
              <div class="data-content" v-html="option.title"></div>
              <div :style="{ flex: 1 }"></div>
            </div>
          </div>
          <div v-for="(callerData, cdindex) in callerDatas" :key="cdindex" class="data-row row-block stretch">
            <div class="data-col col-block" v-for="(option, oindex) in tableOption" :key="oindex" :class="[option.position, { hidden: !option.title }]" :style="{ flex: option.flex, width: 0 }">
              <div v-if="option.value === 'description' && Object.keys(callerData.descriptionData || {}).length" class="data-content description-col col-block" :class="{ alert: false }">
                <div class="description-list-container row-block flex-start flex-wrap">
                  <div class="description-block row-block" v-for="(kv, dindex) in Object.entries(callerData.descriptionData)" :key="dindex" :style="{ width: (100 / 3) + '%' }">
                    <div class="description-content" v-html="'<b>' + kv[0] + '</b>: ' + kv[1]"></div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
              </div>
              <div v-else class="data-content" :class="[option.break ? 'break-line' : 'ellipsis']" :title="(option.info || option.display || (x => x))(callerData[option.value], callerData)" :style="{ color: (option.color || (() => null))(callerData[option.value], callerData), 'max-height': option.maxHeight || 'auto' }" v-html="(option.display || (x => x))(callerData[option.value], callerData) || option.empty || '- -'"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div :style="{ height: '20px' }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ $t('COMMON.button.___return') }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import { defaultEmptyDisplay, svTypeOptions } from '../../constants/global/data'

export default {
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    callerDatas () {
      let callerData = {
        names: (this.regionData.caller_name || '').split('|'),
        descriptions: (this.regionData.QC || '').split('|').map(qcString => qcString.split(';').reduce((result, dataString) => {
          let data = dataString.split('=')
          return { ...result, ...(data.length === 2 ? { [data[0]]: data[1] } : {}) }
        }, {})).filter(x => x)
      }
      let callerDatas = new Array(this.regionData.support_caller_count).fill('').map((_, index) => ({ name: callerData['names'][index], descriptionData: callerData['descriptions'][index] }))
      return callerDatas
    },
    // static
    tableOption () {
      return [
        {
          title: this.$t('DIALOG.caseDetailRegionCaller.table.title.___caller'),
          value: 'name',
          info: value => this.param.callerFiles[value] || '',
          color: null,
          flex: 1,
          position: 'center',
          break: true,
          empty: this.$t(defaultEmptyDisplay.empty)
        },
        {
          title: this.$t('DIALOG.caseDetailRegionCaller.table.title.___description'),
          value: 'description',
          flex: 3
        }
      ]
    },
    // param
    regionData () {
      return this.param.regionData
    },
    // global
    svTypeValueMap () { return svTypeOptions.reduce((map, option) => ({ ...map, [option.value]: option }), {}) }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/caseDetailRegionCaller.vue